import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export const getDateSuffix = (dateString) => {
  const day = dateString.getDate();
  const suffix = ["th", "st", "nd", "rd"][
    day % 10 > 3 || Math.floor((day % 100) / 10) === 1 ? 0 : day % 10
  ];
  return day + suffix;
};

export const formatDateInEntityTimezone = (utcDate, entityTimezone) => {
  if (!utcDate) return "";
  const zonedDate = toZonedTime(utcDate, entityTimezone);
  const formattedZonedDate = format(zonedDate, "MMMM do, yyyy , h:mm a");
  return formattedZonedDate;
};

export const formatDateToISOStartOfDay = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00:00`;
};

export const removeTimezoneFromDateString = (dateString) => {
  if (!dateString) return null;
  const dateWithoutTimezone = dateString.split("Z")[0];
  return new Date(dateWithoutTimezone);
};
